import * as React from 'react';

const styles = require('./NoData.pcss');

interface IState {
    visible: boolean;
}

interface IProps {
    isLoading?: boolean;
}

export class NoData extends React.Component< IProps, IState>{

    constructor(props) {
        super(props);

    }

    render() {
        return (
            <div>
                <div className={styles.noDataBodyText}>
                    <p>There are no funds that match the criteria you have specified.<br />Please try your search again.</p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/NoData/NoData.tsx